// Formats an API timestamp in the viewer's own system timezone.
// The API returns UTC ISO-8601 (trailing 'Z'); if a value ever arrives without timezone
// info we treat it as UTC, so it never renders as a naive local time.
export function formatDateTimeLocal(value?: string | null): string {
  if (!value) return '';
  const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value);
  const d = new Date(hasTz ? value : `${value}Z`);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString();
}

// Formats an API timestamp in US Eastern time regardless of the viewer's system
// timezone — used where the surrounding report is explicitly ET (Metrics tab).
export function formatDateTimeET(value?: string | null): string {
  if (!value) return '';
  const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value);
  const d = new Date(hasTz ? value : `${value}Z`);
  return Number.isNaN(d.getTime())
    ? ''
    : d.toLocaleString(undefined, { timeZone: 'America/New_York', timeZoneName: 'short' });
}

// Formats a NANP phone number for display:
//   +19802521075 → +1 (980) 252-1075
//   9802521075   → (980) 252-1075
// Anything that isn't a 10- or 11-digit (leading 1) number is returned unchanged.
export function formatPhoneNumber(value?: string | null): string {
  if (!value) return '';
  const digits = value.replace(/\D/g, '');
  if (digits.length === 10)
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length === 11 && digits[0] === '1')
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  return value;
}
